import {Component, forwardRef, Input} from '@angular/core';
import {DictionariesService} from "../../service";
import {ICodeName as dictionaryInterface} from "../../models";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "./view-dictionary-base";

@Component({
  selector: 'app-dict-qref-vo4936',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefVo4936ViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [multiple]="multiply"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['name','code']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          <b> {{ item.code }} </b>
          <ng-container *ngIf="!multiply">{{ item.name }}</ng-container>
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <div style="white-space: normal">
            <b> {{ item.code }} </b>
            {{ item.name }}
          </div>
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefVo4936ViewComponent extends ViewDictionaryBase<dictionaryInterface> {
  @Input() multiply: boolean;
  getDictionary = this.dictSrv.getQrefVo4936List();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
